import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Button,
    CardActions,
    CardContent,
    TextField,
    CardHeader,
    Grid, Switch, FormControlLabel
} from "@mui/material";
import {setModal} from "../../../../../Common/App";
import {DialogCard, Loader} from "../../../../../../Components";
import {addStatus, updateStatus} from "../../../Redux/Action";

export const StatusModal = ({type_id, item, setItems}) => {

    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        id: null,
        name: '',
        verb: '',
        type_id: null,
        color: '',
        description: '',
        is_template: 0,
    });

    useEffect(() => {
        if (item) {
            setData({
                id: item.id,
                name: item.name,
                verb: item.verb || '',
                type_id: item.type_id || type_id,
                color: item.color,
                description: item.description,
                is_template: item.is_template || 0,
            });
        }
        if (type_id) {
            setData((prev) => ({
                ...prev,
                type_id: type_id,
            }));
        }
    }, [item, type_id]);

    const handleSaveOrUpdate = async () => {
        setIsLoading(true);
        if (data.id) {
            await updateStatus({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setData({});
                    setItems((prev) => prev.map((item) => (item.id === res.data?.id ? res.data : item)));
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        } else {
            await addStatus({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    const newStatus = res.data;
                    setData({});
                    // push newStatus into the correct item's statuses
                    setItems((prevItems) =>
                        prevItems.map((itm) => {
                            if (itm.id === newStatus.type_id) {
                                return {
                                    ...itm,
                                    statuses: [...(itm.statuses || []), newStatus],
                                };
                            }
                            return itm;
                        })
                    );
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        }
    };

    const handleChange = (e) => {
        setErrors({});
        setDisabled(false);
        const {name, value} = e.target;
        setData({...data, [name]: value});
    }

    const handleSwitchChange = (name, value) => {
        setData((prev) => ({
            ...prev,
            [name]: prev[name] === value ? 0 : value,
        }));
    };

    return (
        <DialogCard>
            <CardHeader 
                title="Status"
                avatar={<Loader isLoading={isLoading} type={"linear"} />}
            />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Name"
                            placeholder={"Document Upload"}
                            value={data?.name || ''}
                            name="name"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Verb"
                            placeholder={"Approved"}
                            value={data?.verb || ''}
                            name="verb"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.verb}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Color"
                            value={data?.color || ''}
                            name="color"
                            placeholder={"#99cc00"}
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.color}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={2}
                            label="Description"
                            value={data?.description || ''}
                            name="description"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.description}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            label={"Is Template"}
                            labelPlacement="start"
                            control={
                                <Switch
                                    color="primary"
                                    size="small"
                                    checked={!!data?.is_template}
                                    onChange={() => handleSwitchChange('is_template', 1)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                        />
                    </Grid>

                </Grid>
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={disabled} variant="contained" color={'primary'} onClick={ handleSaveOrUpdate }>{ data['id'] ? 'Update' : 'Add'}</Button>
            </CardActions>
        </DialogCard>
    )
}